// extracted by mini-css-extract-plugin
export default {"containerFeed2":"ingredients-items_containerFeed2__UN3Zm"};